var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%","width":"100%"}},[_c('GoogleMap',{attrs:{"api_key":"AIzaSyA6TAPuhK96gq9vMpeF27m6icCgqkqn1rM","map_options":{ center: { lat: 37.7749, lng: -122.4194 }, zoom: 8 },"map_id":1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }